import app from '@frontend/application-container';
import { defineComponent, h } from 'vue';
import BarButton from '@components/bar-button';
import { show_curvature_options_modal } from '@features/curvature-combs/state';
import { img } from '@phi/components';
import icon from './curvature-comb-options.svg';
import styles from './index.module.scss';
import { ShowCurvatureCombsOptionsTooltip } from '../show-curvature-combs-options-tooltip';

export const ShowCurvatureCombsOptionsButton = defineComponent({
    setup() {
        return () => h(BarButton, {
            disabled: !app.state.loaded,
            id: 'show-curvature-combs-options-button',
            tippy: 'top',
            onClick: show_curvature_options_modal,
        }, {
            icon: () => img(icon, 'Show curvature combs options', [styles.pad_slight]),
            tooltip: ShowCurvatureCombsOptionsTooltip,
        });
    }
});
